// useGetResource.js
import { keepPreviousData } from "@tanstack/react-query";
import useAuthenticatedQuery from "./useAuthenticatedQuery";

/**
 * Generic "get" hook.
 *
 * @param {string|unknown[]} queryKey
 *   – your cache key (e.g. ["documents", cursor] or ["mydocuments", cursor])
 * @param {string} url
 *   – the endpoint to fetch (e.g. "/api/v1/workpermits" or "/api/v1/users/my-work-permits")
 * @param {object} options
 *   – optional query options (e.g. { staleTime: 0, refetchOnMount: "always" })
 */
const useGetResource = (queryKey, url, options = {}) => {
  const {
    data,
    isLoading,
    error,
    refetch,
    isFetching,
    isPlaceholderData,
    isError,
    isPending,
  } = useAuthenticatedQuery(queryKey, url, {
    placeholderData: keepPreviousData,
    ...options,
  });

  return {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    isPlaceholderData,
    isError,
    isPending,
  };
};

export default useGetResource;
